<template>
    <x-multiselect
        v-bind="$attrs"
        :value="value"
        v-on="$listeners"
        :options="aliases"
        :taggable="true"
        label="name"
        track-by="name"
        :multiple="true"
        @tag="addTag"
        tag-placeholder="Add this as new email"
        placeholder="Search or add a new email"></x-multiselect>
</template>

<script>
import XMultiselect from '@/components/XMultiselect'

export default {
    name: 'ForwardTo',
    components: {XMultiselect},
    props: {
        aliases: {
            type: Array,
            default() {
                return []
            }
        },
        value: {
            type: Array,
            requared: true
        }
    },
    computed: {},
    methods: {
        addTag(newTag) {
            const tag = {
                name: newTag,
            }
            this.aliases.push(tag)
            this.value.push(tag)
        }
    }
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/vue-component";

</style>
